import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root:{
    marginTop:'10px',
    height:'100%',
    width: '100%',
  },
  successDialog: {
    padding: 0
  },
  successContentWrapper: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    width: '480px',
    padding: '6px 8px'
  },
  successTitle: {
    fontSize: '18px',
    fontWeight: '600',
    color: theme.palette.grey.grey700,
    lineHeight: '130%',
    letterSpacing: '-0.18px',
    marginTop: '22px',
    textAlign: 'center',
  },
  successContextName: {
    fontSize: '18px',
    color: theme.palette.grey.grey700,
    lineHeight: '140%',
    padding: '13px 68px',
    background: theme.palette.grey.grey100,
    marginTop: '8px',
    width: '371px',
    textAlign: 'center',
    borderRadius: '4px'
  },
  successIcon: {
    display: 'block',
    width: '38px',
    height: '38px',
  },
  successIconWrapper: {
    padding: '15px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    background: theme.palette.primary.primary100
  },
  successButtonWrapper: {
    marginTop: '32px',
    '& > :first-of-type': {
      marginRight: '32px'
    }
  }

}));

export default useStyles;
